module.exports = "https://web-assets.ifttt.com/packs/media/partners/community-ee2699de.svg";